import React from "react";
import { useTranslation, Trans } from "react-i18next";
import Content from "./Content";
import useStyles from "./styles";

export default function Contact() {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Content>
      <span className={classes.text}><Trans>{t("contact.content")}</Trans></span>
      <p>
        <a href="mailto:contact@youthforclimateadaptation.org">contact@youthforclimateadaptation.org</a>
      </p>
    </Content>
  );
}
